import { render, staticRenderFns } from "./baiduMap.vue?vue&type=template&id=48054c04&scoped=true&"
import script from "./baiduMap.vue?vue&type=script&lang=js&"
export * from "./baiduMap.vue?vue&type=script&lang=js&"
import style0 from "./baiduMap.vue?vue&type=style&index=0&id=48054c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48054c04",
  null
  
)

export default component.exports